<div class="pi-modal" role="dialog" aria-labelledby="pi-modal-que-es-title">
  <header class="pi-modal__header" [class.pi-modal__header--scrolled]="isScrolled">
    <div class="pi-modal__header-text">
      <h2 id="pi-modal-que-es-title" class="pi-modal__title">
        ¿Qué es la Pensión por<span class="pi-modal__title-br" aria-hidden="true"></span>Invalidez?
      </h2>
    </div>
    <ds-icon-button-v2
      class="pi-modal__close"
      icon="Close"
      size="s"
      emphasis="terciary"
      ariaLabel="Cerrar"
      (clicked)="cerrar()">
    </ds-icon-button-v2>
  </header>

  <div class="pi-modal__body" (scroll)="onScroll($event)">
    <div class="pi-modal__content">
      <div class="pi-modal__intro">
        <p class="pi-modal__intro-text">
          Es un beneficio mensual para afiliados que la Comisión Médica de la Superintendencia de
          Pensiones declaró inválidos, por perder parcial o totalmente su capacidad de trabajo.<br /><br />
          Según el porcentaje de pérdida, existen dos tipos de Pensión de Invalidez:
        </p>
      </div>

      <div class="pi-modal__tipos">
        <ng-container *ngFor="let tipo of tipos; let last = last">
          <div class="pi-modal__tipo">
            <span class="pi-modal__tipo-dot" aria-hidden="true"></span>
            <div class="pi-modal__tipo-text">
              <p class="pi-modal__tipo-title">{{ tipo.title }}</p>
              <p class="pi-modal__tipo-desc">{{ tipo.description }}</p>
            </div>
          </div>
          <div *ngIf="!last" class="pi-modal__tipo-divider" aria-hidden="true"></div>
        </ng-container>
      </div>

      <div class="pi-modal__pasos-panel">
        <h3 class="pi-modal__pasos-title">Conoce el paso a paso del trámite:</h3>

        <div class="pi-modal__pasos-card">
          <div class="pi-modal__pasos-line" aria-hidden="true"></div>
          <ol class="pi-modal__pasos">
            <li *ngFor="let paso of pasos" class="pi-modal__paso">
              <span class="pi-modal__paso-icon" aria-hidden="true">
                <ds-icon [name]="paso.icon" size="16px"></ds-icon>
              </span>
              <span class="pi-modal__paso-label">{{ paso.label }}</span>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</div>
